export default __webpack_public_path__ + "static/media/solar-chakra.704571cb.png";